<div class="logo-container">
  <a
    routerLink="/"
    [state]="{ scrollRestoration: 'top' }"
    (click)="closeMenu()"
    [attr.aria-label]="'GO_TO_HOMEPAGE' | translate"
  >
    <picture>
      <source srcset="../../../../../assets/img/mb_logo_star_v1.1.apng" type="image/apng" />
      <img class="logo" src="assets/img/mb_logo_star.svg" alt="Mercedes-Benz Media Logo" />
    </picture>
  </a>
</div>
@if (isSearchInputFieldClosed) {
  <div class="desktop-view">
    <div class="flex-row-center">
      <wb-header-button label="{{ 'OPEN_MENU' | translate }}" (click)="toggleNavigationMenu()">
        <wb-icon name="bds/menu/16"></wb-icon>
      </wb-header-button>
      <a
        routerLink="/"
        [state]="{ scrollRestoration: 'top' }"
        (click)="closeMenu()"
        [attr.aria-label]="'GO_TO_HOMEPAGE' | translate"
        class="big-logo-link"
      >
        <img src="assets/img/wm_mb-media.svg" width="138" height="11" alt="Mercedes-Benz Media" />
      </a>
    </div>
    <div class="flex-row-center">
      <wb-header-language-menu aria-label="{{ 'LANGUAGE_MENU' | translate }}">
        <ng-container *ngTemplateOutlet="languageList"> </ng-container>
      </wb-header-language-menu>
      @if (user$ | async; as user) {
        <wb-header-button label="{{ 'OPEN_PROFILE' | translate }}" (click)="openProfileModal()">
          <div class="icon-text-button">
            <wb-icon name="bds/user/16"></wb-icon>
            <wb-text size="s">{{ user.username }}</wb-text>
          </div>
        </wb-header-button>
      } @else {
        <wb-header-button label="{{ 'LOGIN' | translate }}" (click)="login()">
          <div class="icon-text-button">
            <wb-icon name="bds/login/16"></wb-icon>
            <wb-text size="s">{{ 'LOGIN' | translate }}</wb-text>
          </div>
        </wb-header-button>
      }
      <wb-header-button label="{{ 'OPEN_SEARCH' | translate }}" (click)="toggleSearchInputField(false)">
        <wb-icon name="bds/search/16"></wb-icon>
      </wb-header-button>
    </div>
  </div>
  <div class="tablet-view">
    <!-- Tablet -->
    <div class="flex-row-center">
      <wb-header-button label="{{ 'OPEN_MENU' | translate }}" (click)="toggleNavigationMenu()">
        <wb-icon name="bds/menu/16"></wb-icon>
      </wb-header-button>
      <wb-header-language-menu aria-label="{{ 'LANGUAGE_MENU' | translate }}">
        <ng-container *ngTemplateOutlet="languageList"> </ng-container>
      </wb-header-language-menu>
    </div>
    <div class="flex-row-center">
      @if (user$ | async; as user) {
        <wb-header-button label="{{ 'OPEN_PROFILE' | translate }}" (click)="openProfileModal()">
          <div class="icon-text-button">
            <wb-icon name="bds/user/16"></wb-icon>
            <wb-text size="s">{{ user.username }}</wb-text>
          </div>
        </wb-header-button>
      } @else {
        <wb-header-button label="{{ 'OPEN_PROFILE' | translate }}" (click)="login()">
          <div class="icon-text-button">
            <wb-icon name="bds/login/16"></wb-icon>
            <wb-text size="s">{{ 'LOGIN' | translate }}</wb-text>
          </div>
        </wb-header-button>
      }
      <wb-header-button label="{{ 'OPEN_SEARCH' | translate }}" (click)="toggleSearchInputField(false)">
        <wb-icon name="bds/search/16"></wb-icon>
      </wb-header-button>
    </div>
  </div>
  <div class="mobile-view">
    <!-- Mobile -->
    <div class="flex-row-center">
      <wb-header-button label="{{ 'OPEN_MENU' | translate }}" (click)="toggleNavigationMenu()">
        <wb-icon name="bds/menu/16"></wb-icon>
      </wb-header-button>
      <wb-header-button label="{{ 'OPEN_MY_CONTENT' | translate }}" (click)="openMyContent()">
        <wb-icon name="bds/bookmark/16"></wb-icon>
        @if (notificationCount) {
          <wb-counter class="fav-counter" [value]="notificationCount" variant="primary"></wb-counter>
        }
      </wb-header-button>
    </div>
    <div class="flex-row-center">
      @if (user$ | async; as user) {
        <wb-header-button label="{{ 'OPEN_PROFILE' | translate }}" (click)="openProfileModal()">
          <wb-icon name="bds/user/16"></wb-icon>
        </wb-header-button>
      } @else {
        <wb-header-button label="{{ 'OPEN_PROFILE' | translate }}" (click)="login()">
          <wb-icon name="bds/login/16"></wb-icon>
        </wb-header-button>
      }
      <wb-header-button label="{{ 'OPEN_SEARCH' | translate }}" (click)="toggleSearchInputField(false)">
        <wb-icon name="bds/search/16"></wb-icon>
      </wb-header-button>
    </div>
  </div>
} @else {
  <mb-header-search-input-field
    [@inOutAnimation]
    (closeSearchInputField)="toggleSearchInputField(true)"
  ></mb-header-search-input-field>
}

<ng-template #languageList>
  @for (lang of languages; track lang.isoLang) {
    <wb-header-language-menu-item (click)="changeLanguage(lang.isoLang)" [active]="currentLanguage === lang.isoLang">
      {{ lang.label }}
    </wb-header-language-menu-item>
  }
</ng-template>
